import { render, staticRenderFns } from "./EmailNotify.vue?vue&type=template&id=a4a7b1b2&scoped=true&"
import script from "./EmailNotify.vue?vue&type=script&lang=js&"
export * from "./EmailNotify.vue?vue&type=script&lang=js&"
import style0 from "./EmailNotify.vue?vue&type=style&index=0&id=a4a7b1b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a7b1b2",
  null
  
)

export default component.exports